import React, { useState } from 'react';
import { List, Button, Modal, Popconfirm, Select, Typography } from 'antd';
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons';

const { Text } = Typography;

function formatSessionTime(value) {
  if (!value) return '刚刚';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '刚刚';

  const now = new Date();
  const sameDay = date.toDateString() === now.toDateString();
  if (sameDay) {
    return date.toLocaleTimeString('zh-CN', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  const sameYear = date.getFullYear() === now.getFullYear();
  return date.toLocaleDateString('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    ...(sameYear ? {} : { year: 'numeric' })
  });
}

function sessionTitle(session) {
  return session.title || '新会话';
}

function ConversationList({ sessions, currentSession, onSelect, agents, onNewConversation, onDelete }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);

  const handleNew = () => {
    if (selectedAgent) {
      onNewConversation(selectedAgent);
      setModalVisible(false);
      setSelectedAgent(null);
    }
  };

  return (
    <div className="conversation-panel">
      <Button type="primary" icon={<PlusOutlined />} onClick={() => setModalVisible(true)} block className="new-conversation-button">
        新建会话
      </Button>
      <List
        dataSource={sessions}
        renderItem={session => (
          <List.Item
            onClick={() => onSelect(session)}
            className={currentSession?.id === session.id ? 'conversation-item active' : 'conversation-item'}
            actions={onDelete ? [
              <Popconfirm
                key="delete"
                title="删除这个会话？"
                okText="删除"
                cancelText="取消"
                onConfirm={(event) => {
                  event?.stopPropagation?.();
                  onDelete(session);
                }}
                onCancel={(event) => event?.stopPropagation?.()}
              >
                <Button
                  type="text"
                  danger
                  icon={<DeleteOutlined />}
                  onClick={(event) => event.stopPropagation()}
                />
              </Popconfirm>
            ] : []}
          >
            <List.Item.Meta
              title={(
                <div className="conversation-title-row">
                  <Text className="conversation-title" ellipsis>{sessionTitle(session)}</Text>
                  <span className="conversation-time">{formatSessionTime(session.updatedAt || session.createdAt)}</span>
                </div>
              )}
              description={(
                <div className="conversation-meta">
                  <span className="conversation-agent">{session.agent?.displayName || '万能的我'}</span>
                  {currentSession?.id === session.id && <span className="conversation-current">当前</span>}
                </div>
              )}
            />
          </List.Item>
        )}
      />
      <Modal title="选择助手" visible={modalVisible} onOk={handleNew} onCancel={() => { setModalVisible(false); setSelectedAgent(null); }} okText="开始聊天" cancelText="取消" okButtonProps={{ disabled: !selectedAgent }} destroyOnClose>
        <Select style={{ width: '100%' }} value={selectedAgent || undefined} placeholder="请选择一个助手" onChange={setSelectedAgent} options={agents.map(a => ({ value: a.id, label: a.displayName || '万能的我' }))} />
      </Modal>
    </div>
  );
}

export default ConversationList;
